// Projects: the Projects page (V4Projets) and the portfolio (V4Portfolio).
export default {
  titre: 'Projects',
  sousTitre: 'What you follow: its brands, its material, its scope',
  erreur: {
    illisible: 'Could not load the project',
    creation: 'Could not create the project',
    changement: 'Could not apply the change',
    envoi: 'Could not upload the file',
    depot: 'Could not add the document',
    suppression: 'Could not delete',
  },
  dimension: {
    pyramide: 'age breakdown',
    femmes: 'share of women by age',
    diplome: 'education',
    urbanite: 'place of residence',
    origine: 'origin',
    religion: 'religion',
  },
  kind: {
    brief: { l: 'brief', aide: 'a brief, specifications, a request' },
    presentation: { l: 'presentation', aide: 'a deck, a presentation, a pitch' },
    bible: { l: 'bible', aide: 'the bible, the concept, the paper format' },
    script: { l: 'script', aide: 'a script, a running order' },
    sondage: { l: 'survey', aide: 'figures on a population, with a fieldwork date' },
    etude: { l: 'study', aide: 'an analysis, a report, a usage and attitudes study' },
    donnees: { l: 'data', aide: 'an export, a spreadsheet, audience figures' },
    presse: { l: 'press', aide: 'an article, a press review' },
    veille: { l: 'market watch', aide: 'the competition, a benchmark' },
    compte_rendu: { l: 'minutes', aide: 'the minutes of a meeting' },
    contrat: { l: 'contract', aide: 'a contract, a tender' },
    note: { l: 'note', aide: 'what you know that is written down nowhere' },
    media: { l: 'media', aide: 'a poster, an ad, a teaser' },
  },
  pastille: {
    brief: 'brief',
    presentation: 'presentation',
    bible: 'bible',
    script: 'script',
    presse: 'press',
    veille: 'market watch',
    compte_rendu: 'minutes',
    contrat: 'contract',
    sondage: 'survey',
    etude: 'study',
    donnees: 'data',
    note: 'note',
    media: 'media',
  },
  choix: {
    titre: 'Your projects',
    texte: 'A project is what you follow: a show, a film, a product range. It holds its brands, the material you add to it, and the territories it is allowed to look at. Until one is open, there is nothing to show.',
    marques: '{n} brands | {n} brand | {n} brands',
    territoires: '{n} territories | {n} territory | {n} territories',
  },
  archive: 'archived',
  creer: {
    aide: 'Create a project',
    bouton: 'New project',
    nom: 'Project name: The Voice, Koh-Lanta…',
    description: 'What it is about. This text goes into the framing of studies.',
    marche: 'the market decides which population is drawn',
    enCours: 'creating…',
    valider: 'Create',
  },
  annuler: 'cancel',
  changer: 'switch project',
  marques: {
    titre: 'Brands · {n}',
    ajouter: 'add a brand',
    aucune: 'No brands. A project without a brand has nothing to audit: that is the first step.',
  },
  territoires: {
    titre: 'Territories · {n}',
    aucun: 'No territories. Your brands’ territories appear here as soon as an audit detects them.',
    principal: 'main',
    via: 'via {liste}',
    uneMarque: 'a brand',
    ouvert: 'opened to the project',
  },
  matiere: {
    titre: 'What you have added · {n}',
    aideDeposer: 'Add a study, a survey, an export or a note',
    deposer: 'add',
    confidentialite: 'This material stays in this project. It joins neither the shared territories nor Orion’s calibration bench: a study you paid for does not tune anyone else’s engine.',
    aideEnvoi: 'Uploads the file to the project’s private storage',
    envoi: 'uploading…',
    remplacer: 'replace the file',
    choisir: 'choose a file',
    envoye: '✓ uploaded',
    ouColler: 'or paste the text below',
    titreDoc: 'Title: what it is, in plain words',
    auteur: 'Who produced it (institute, agency)',
    dateTerrain: 'The FIELDWORK date, not the publication date',
    population: 'Who answered: “1,002 French people aged 18 and over”',
    texte: 'Or paste the text directly: a note is as good as a study, and often more up to date.',
    depotEnCours: 'adding…',
    deposerEtLire: 'Add and read',
    incomplet: 'A title is required, plus a file or some text.',
    rien: 'Nothing added yet. The studies you have already paid for and last season’s surveys frame this project’s panels: without them, Orion starts from what it knows about the world, not about you.',
    lecture: 'reading…',
    illisible: 'unreadable',
    aideRetirer: 'The project’s panels will no longer read it',
    aideRemettre: 'The project’s panels will read it again',
    retirer: 'remove from context',
    remettre: 'restore',
    aideSupprimer: 'Removes the document from the project',
    supprimer: 'delete',
    terrain: 'fieldwork {date}',
  },
  population: {
    titre: 'Who we ask in this project',
    avant: 'What you have added and validated decides the make-up of the twins drawn here. Anything undocumented follows the territory. Your figures correct',
    qui: 'who',
    apres: 'we ask, never what they answer: adjusting the answers would mean tuning the instrument to a result already known.',
    terrain: 'fieldwork {date}',
    sansDate: 'no fieldwork date',
  },
  chiffres: {
    titre: 'Figures to review · {n}',
    valides: '{n} validated',
    texte: 'Every figure read in your documents waits for your review before it is used to measure Orion. A “38%” read where the document said “3.8 out of 8” would tell the engine it is wrong when it is right, and we would correct in the wrong direction without anything looking off.',
    misAJour: 'Project population updated: {n} rows. The twins drawn here now follow this make-up.',
    audience: 'describes your audience',
    avertissement: 'Validating this figure will change the make-up of the twins drawn in this project.',
    terrain: 'fieldwork {date}',
    justeTirer: 'the figure is right, draw on it',
    juste: 'the figure is right',
    malLu: 'misread',
    validesTitre: 'Validated',
  },
  archiver: {
    aideArchiver: 'The project and its material are kept, filed away',
    aideReactiver: 'The project goes back among the active ones',
    archiver: 'archive this project',
    reactiver: 'reactivate this project',
  },
  chargement: 'Loading the project…',
  poids: {
    mo: '{n} MB',
    ko: '{n} KB',
  },

  // ── The portfolio ─────────────────────────────────────────────────────────
  portefeuille: {
    titre: 'Portfolio',
    nbDossiers: '{n} projects | {n} project | {n} projects',
    nbMarques: '{n} brands | {n} brand | {n} brands',
    insight: 'Insight of the day',
    whiteSpace: 'White space detected for {marque}: “{label}”',
    whiteSpaceAngle: 'White space detected for {marque}, “{label}”: {angle}',
    dossier: 'project {nom}',
    detection: 'detected {date}',
    detectionAide: 'White space detected automatically from the last 90 days of signals',
    force: 'strength {n}/100',
    forceAide: 'White space opportunity score: see the editorial brief',
    ouvrirDossier: 'Open the project',
    ouvrirChaine: 'Open the dashboard',
    masquer: 'Hide this insight. Nothing is deleted: it comes back if a new white space is detected',
    ouvrirDeepDive: 'Open the deep dive',
    compare: 'Compared with the previous audit: {source}',
    mesDossiers: 'My projects · {n}',
    porte: 'A project holds its brands, what you add to it, and the territories it looks at.',
    creerAide: 'Create a project: a show, a film, a product range',
    nouveau: 'New project',
    ouvert: 'open project',
    scoreAide: 'Brand score / 100',
    aAnalyser: 'to analyse',
    autres: '+ {n} more',
    aucuneMarque: 'No brands: that is the first step.',
    territoiresAide: 'The project’s territories: those of its brands appear here, along with those an administrator opens to it',
    territoires: 'territories | territory | territories',
    deposesAide: 'What you have added, which frames the project’s studies',
    deposes: 'added | added | added',
    isosAide: 'Twins sent out each day, Arena and Grid, across all the project’s brands',
    isosJour: 'twins / day',
    aucun: 'No projects. A project is what you follow: a show, a film, a product range. It holds its brands, the material you add to it and the territories it looks at.',
    sansDossier: 'Brands without a project · {n}',
  },
}
